import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MediaLibraryDialog } from '../../dialog/library/component';

type TComponentState = 'editing' | 'present' | 'empty' | 'processing' | 'disabled';

@Component({
  standalone: false,
  selector: 'media-control',
  templateUrl: './template.html',
  styleUrl: './style.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: MediaControl,
    },
  ],
})
export class MediaControl implements ControlValueAccessor {
  @Input() emptyButtonLabel = 'Choose image';
  @Input() presentButtonLabel = 'Replace image';

  imageId: string;
  previousState: TComponentState = 'empty';
  state: TComponentState = 'empty';

  onTouched: Function = () => {};
  onChange: (value: string) => void = (value: string) => {};

  constructor(private dialog: MatDialog) {}

  setState(state: TComponentState) {
    this.previousState = this.state;
    this.state = state;
  }

  restorePreviousState() {
    this.state = this.previousState;
  }

  imageChosen(image: string) {
    this.imageId = image;
    this.onChange(image);
    this.setState('present');
  }

  async enableEditing() {
    this.setState('editing');
    const dialogRef = this.dialog.open(MediaLibraryDialog, {
      width: '1000px',
      height: '90vh',
    });
    dialogRef.afterClosed().subscribe((imageId: string) => {
      if (imageId) {
        this.imageChosen(imageId);
      } else {
        this.restorePreviousState();
      }
    });
  }

  writeValue(imageId: string | undefined) {
    this.imageId = imageId;
    if (!!this.imageId) {
      this.setState('present');
    } else {
      this.setState('empty');
    }
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.state == 'disabled';
    } else {
      this.state == 'present';
    }
  }
}
